// Messages for operator/marketing/ContentPage (auto-merged by lib/i18n.ts).
export const en = {
  'operator.marketing_cms.page_head': '{page} — Website content',
  'operator.marketing_cms.page_desc':
    'Blank fields fall back to the built-in copy. Switch page and language with the tabs.',
  'operator.marketing_cms.save': 'Save draft',
  'operator.marketing_cms.publish': 'Publish',
  'operator.marketing_cms.unpublished': 'Unpublished changes',
  'operator.marketing_cms.preview_title': 'Live preview',
  'operator.marketing_cms.preview_show': 'Show preview',
  'operator.marketing_cms.preview_hide': 'Hide preview',
  'operator.marketing_cms.preview_open_tab': 'Open in new tab',
}

export const zhTW = {
  'operator.marketing_cms.page_head': '{page} — 網站內容',
  'operator.marketing_cms.page_desc': '空白欄位會使用內建預設文案。以分頁切換頁面與語言。',
  'operator.marketing_cms.save': '儲存草稿',
  'operator.marketing_cms.publish': '發布',
  'operator.marketing_cms.unpublished': '尚未發布的變更',
  'operator.marketing_cms.preview_title': '即時預覽',
  'operator.marketing_cms.preview_show': '顯示預覽',
  'operator.marketing_cms.preview_hide': '隱藏預覽',
  'operator.marketing_cms.preview_open_tab': '在新分頁開啟',
}
